import type { ModelsResolver } from "@/models/resolvers";
import { revisionDefaultFields } from "@/models/resolvers";
import { useLogger } from "@/composables/logger";

const { info: logInfo } = useLogger("SCENARIOS_WELL_PROPERTIES_RESOLVER");

export default {
  queries: {
    scenario_well_properties: {
      bottom_casing: (parent, args, cache, info) => {
        return parent.bottom_casing_id
          ? { __typename: "casings", id: parent.bottom_casing_id }
          : null;
      },
      bottom_tubing: (parent, args, cache, info) => {
        return parent.bottom_tubing_id
          ? { __typename: "tubings", id: parent.bottom_tubing_id }
          : null;
      },
      top_casing: (parent, args, cache, info) => {
        return parent.top_casing_id
          ? { __typename: "casings", id: parent.top_casing_id }
          : null;
      },
      top_tubing: (parent, args, cache, info) => {
        return parent.top_tubing_id
          ? { __typename: "tubings", id: parent.top_tubing_id }
          : null;
      },
      deviation_survey: (parent, args, cache, info) => {
        return parent.deviation_survey_id
          ? { __typename: "deviation_survey", id: parent.deviation_survey_id }
          : null;
      }
    }
  },
  optimistic: {
    insert_revisions_scenario_well_properties_revisions: (
      vars,
      cache,
      info
    ) => {
      logInfo("Optimistic", { vars, cache, info });
      const affectedRows = vars.objects.length;

      return {
        affected_rows: affectedRows,
        __typename:
          "revisions_scenario_well_properties_revisions_mutation_response",
        returning: vars.objects.map(obj => ({
          __typename: "revisions_scenario_well_properties_revisions",
          id: obj.id,
          scenario_well_properties_view: {
            __typename: "scenario_well_properties",
            deviation_survey: null,
            ...obj,
            ...revisionDefaultFields(obj)
          }
        }))
      };
    }
  }
} as ModelsResolver;
